import './Container.scss';

export const Container = ({ children }) => (
  <div className="Container">
    {children}
  </div>
)